<template>
    <div class="p10" v-loading.body="loading">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="6">
                <h1 style="padding-top:5px;">其他收付单</h1>
            </el-col>
            <el-col :span="18" class="tr">
                <template v-if="infoData.is_jindie == 1">
                    <el-button type="primary" size="small" 
                        @click="backJindie"
                        v-if="buttonConfig.isRevokeJindie">
                        撤回金蝶
                    </el-button>
                </template>
                <template v-if="infoData.is_jindie == 0 && infoData.status != 11">
                    <ly-button-time @timeUpdate="timeUpdate" 
                        :infoid="infoId"
                        :type="24"
                        :date="infoData.data.work_time" 
                        v-if="buttonConfig.isUpdateTime">
                    </ly-button-time>
                    <ly-invalid-button size="small" :infoId="infoId" isRoute="api/qitasf" :callback="queryInfoData" isStyle="其他收付"></ly-invalid-button>
                    <ly-router-button
                        size="small"
                        :route="'/bill/' + currRoute.path + '/edit/' + infoId"
                        type="primary"
                        v-if="buttonConfig.isEdit">
                            <i class="fa fa-edit"></i>&nbsp;修改
                    </ly-router-button>
                    <el-button type="primary" size="small" 
                        :disabled="isdisabled"
                        @click="sendJindie"
                        v-if="buttonConfig.isSendJindie">
                        发送金蝶
                    </el-button>
                </template>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <el-card class="box-card mt15">
            <el-row>
                <el-col :span="12">
                    <el-button-group>
                        <template v-if="infoData.prevId && infoData.prevId > 0">
                            <el-button type="info"  size="small" @click="toggoleInfo(infoData.prevId)">
                                <i class="fa fa-chevron-left"></i> 前一张
                            </el-button>
                        </template>
                        <template v-if="infoData.nextId && infoData.nextId > 0">
                            <el-button type="info"  size="small" @click="toggoleInfo(infoData.nextId)">
                                后一张 <i class="fa fa-chevron-right"></i> 
                            </el-button>
                        </template>
                    </el-button-group>
                </el-col>
                <el-col :span="12" class="tr">
                    <template v-if="infoData.is_jindie == 1">
                        <el-tag type="warning">已发送金蝶</el-tag>
                    </template>
                    <template v-else>
                        <el-tag type="warning">未发送金蝶</el-tag>
                    </template>
                    <template v-if="infoData.status == 11">
                        <el-tag type="warning">已作废</el-tag>
                    </template>
                </el-col>
            </el-row>
        </el-card>

        <!-- 客户列表 start -->
        <ly-table 
            :head="customerConfig.head" 
            :data="infoData.data" 
            :config="customerConfig.config"
            class="mt15">
        </ly-table>
        <!-- 客户列表 end -->
        <!-- 处理记录 start -->
        <el-card class="box-card mt15">
            <template slot='header'>
            <div>
                <span>处理记录</span>
            </div>
            </template>
            <p class="f12 mt10 ctext" v-for="el in infoData.history">
                {{el}}
             </p>
        </el-card>
        <!-- 处理记录 end -->
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'
    import InfoConfig from './info-config'
    import LyTable from '@c/table'
    import LyTag from '@c/tag'
    import LyRouterButton from '@c/router-button'
    import LyInvalidButton from '@c/button-invalid'
    import LyButtonTime from '@c/button-time'
    export default {
        mixins: [
            InfoConfig
        ],
        components: {
            LyTable,
            LyTag,
            LyRouterButton,
            LyInvalidButton,
            LyButtonTime
        },
        data () {
            return {
                infoId: '0',
                loading: false,
                isdisabled: false,
                infoData: {
                    data: []
                }, // 详情的数据，包含货品数据、处理记录
                buttonConfig: {} // 按钮的配置
            }
        },
        computed: {
            ...mapGetters('route', [
                'currRoute'
            ])
        },
        watch: {
            '$route' (to, from) {
                // 路由变化时，更新配置
                if (to.name === 'PaymentOtherpayInfo') {
                    this.queryInfoData()
                }
            }
        },
        mounted () {
            this.queryInfoData()
        },
        methods: {
            /**
             * 发送金蝶
             * @return {[type]} [description]
             */
            sendJindie () {                
                this.$confirm('确认要发送金蝶？','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    this.isdisabled = true
                    this.$api.create('api/qitasfjd',{
                        id: this.infoId,
                        type: this.infoData.type
                    }).then(() => {
                        this.isdisabled = false
                        this.$message({
                            message: '已发送金蝶',
                            type: 'success'
                        })
                        this.queryInfoData()
                    }).catch((err) => {
                        this.isdisabled = false
                        this.$message({
                            message: err,
                            type: 'warning'
                        })
                        this.queryInfoData()
                    })
                }).catch(() => {})
            },
            /**
             * 从金蝶撤销
             * @return {[type]} [description]
             */
            backJindie () {          
                this.$confirm('确认已删除金蝶单据并进行撤回处理？','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {      
                    this.$api.query('api/qitasfjd',{
                        id: this.infoId,
                        type: this.infoData.type
                    }).then(() => {
                        this.$message({
                            message: '已撤销',
                            type: 'success'
                        })
                        this.queryInfoData()
                    }).catch((err) => {
                        this.$message({
                            message: err,
                            type: 'warning'
                        })
                    })
                }).catch(() => {})
            },
            /**
             * 详情页面的切换
             */
            toggoleInfo (id) {
                // 跳转到的路由
                let path = '/bill/' + this.currRoute.path + '/info/' + id
                this.routerJump(path)
            },
            /**
             * 路由跳转处理
             * @param  {[type]} path [description]
             * @return {[type]}      [description]
             */
            routerJump (path) {
                path = path.replace('#', '')
                this.loading = true
                this.$router.push(path)
            },
            /**
            /**
             * 获取详情的数据
             */
            queryInfoData () {
                this.readRouteConfig()
                // 获取详情的ID
                this.infoId = this.$route.params.id
                this.$api.query(this.currRoute.api , null, [this.infoId]).then((rs) => {
                    this.loading = false
                    let productData = []
                    productData.push(rs.data)
                    rs.data = productData
                    this.infoData = rs
                }).catch((error) => {
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 读取当前页面的路有配置
             */
            readRouteConfig () {
                // 获得当前页面的配置
                 let routeConfig = this.$utils.readPageConfig(this.currRoute, 'info')
                // 获得button的配置
                if (routeConfig && routeConfig.config) { 
                    this.buttonConfig = routeConfig.config.button ? JSON.parse(routeConfig.config.button || '') : {}
                }
            },
            /*
            * 作废当前页面
            *
            */
            // sendInvalid () {
            //     this.$api.delete('api/qitasf', {
            //         id: this.infoId
            //     }).then((rs) => {
            //         this.$message({
            //             message: '已作废',
            //             type: 'success'
            //         })
            //         this.queryInfoData()
            //     }).catch((err) => {
            //         this.$message({
            //             message: err,
            //             type: 'warning'
            //         })
            //     })
            // }
            /**
             * 日期修改之后的事件监听
             */
            timeUpdate () {
                // 详情数据刷新
                this.queryInfoData()
            }
        }
    }
</script>